import styled from '@emotion/styled';
import { colors, Typography } from '@ui-components/neo.tax';

export type InstructionListProps = {
  $listStyle?: React.CSSProperties['listStyleType'];
};
export const InstructionList = styled.ol<InstructionListProps>(({ $listStyle }) => ({
  marginTop: 10,
  textAlign: 'left',
  listStyle: $listStyle || 'disc',
  marginBottom: '1em',
  paddingLeft: 40,
}));

export const InstructionListItem = styled.li({
  fontSize: 14,
  lineHeight: '14px',
  color: colors.gray[500],
  marginTop: 8,
  textAlign: 'left',
});

export const InstructionsIntroText = styled(Typography)({
  color: colors.gray[500],
});

export const InstructionsLink = styled.a({
  color: colors.primary[600],
  fontWeight: 600,
});
